import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {RouterModule} from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {JwBootstrapSwitchNg2Module} from 'jw-bootstrap-switch-ng2';
import {FixedPluginComponent} from './fixed-plugin/fixed-plugin.component';
import {AngularMultiSelectModule} from 'angular2-multiselect-dropdown';
import {PictureUploadComponent} from './picture-upload/picture-upload.component';
import {NotifPrimaryComponent} from './notif-primary/notif-primary.component';
import {NotifInfoComponent} from './notif-info/notif-info.component';
import {NotifWarningComponent} from './notif-warning/notif-warning.component';
import {NotifDangerComponent} from './notif-danger/notif-danger.component';
import {NotifModalComponent} from './notif-modal/notif-modal.component';
import {NotifSuccessComponent} from './notif-success/notif-success.component';
import {GfxModalComponent} from './gfx-modal/gfx-modal.component';
import {NgbdModalContent} from './gfx-modal/NgbdModalContent';
import {AppContentDirective} from '../directives/app-content.directive';
import {ModalHostCompDirective} from '../directives/modal-host-comp.directive';
import {GfxModalHostComponent} from './gfx-modal-host/gfx-modal-host.component';
import {NgxSpinnerModule} from 'ngx-spinner';
import {I18nComplementIdsComponent} from '../i18n-complement-ids/i18n-complement-ids.component';
import {GfxMaterialModule} from './gfx-material/gfx-material.module';
import {FlexLayoutModule} from '@angular/flex-layout';
import {GfxNgxMatSelectSearchComponent} from './gfx-ngx-mat-select-search/gfx-ngx-mat-select-search.component';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {ConfirmDialogComponent} from './confirm-dialog/confirm-dialog.component';
import {BeMsgErrorComponent} from './be-msg-error/be-msg-error.component';
import {DialogErrorViewComponent} from './dialog-error-view/dialog-error-view.component';
import {ErrViewComponent} from './err-view/err-view.component';
import {GoogleDialogComponent} from './GoogleDialog/GoogleDialog.component';
import {BreadcrumbComponent} from './breadcrumb/breadcrumb.component';
import {GfxHostComponent} from './gfx-host/gfx-host.component';
import {AppTitreComponent} from './app-titre/app-titre.component';
import {FileInputComponent} from './file-input/file-input.component';
import { AppTimelineComponent } from './app-timeline/app-timeline.component';
import {UploadImageDirective} from '../directives/upload-image.directive';

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        JwBootstrapSwitchNg2Module,
        NgbModule,
        AngularMultiSelectModule,
        NgxSpinnerModule,
        GfxMaterialModule,
        FlexLayoutModule,
        NgxMatSelectSearchModule
    ],
    declarations: [
        GfxModalComponent,
        GfxNgxMatSelectSearchComponent,
        ConfirmDialogComponent,
        I18nComplementIdsComponent,
        FixedPluginComponent,
        PictureUploadComponent,
        NotifPrimaryComponent,
        NotifInfoComponent,
        NotifWarningComponent,
        NotifDangerComponent,
        NotifModalComponent,
        NotifSuccessComponent,
        NgbdModalContent,
        ModalHostCompDirective,
        AppContentDirective,
        GfxModalHostComponent,
        ErrViewComponent,
        BeMsgErrorComponent,
        DialogErrorViewComponent,
        GoogleDialogComponent,
        AppTitreComponent,
        BreadcrumbComponent,
        GfxHostComponent,
        FileInputComponent,
        AppTimelineComponent,
        UploadImageDirective
    ],
    exports: [
        GfxModalComponent,
        GfxNgxMatSelectSearchComponent,
        ConfirmDialogComponent,
        FixedPluginComponent,
        PictureUploadComponent,
        NotifPrimaryComponent,
        NotifInfoComponent,
        NotifWarningComponent,
        NotifDangerComponent,
        NotifModalComponent,
        NotifSuccessComponent,
        NgbdModalContent,
        GfxModalHostComponent,
        GoogleDialogComponent,
        AppTitreComponent,
        BreadcrumbComponent,
        GfxHostComponent,
        FileInputComponent,
        AppTimelineComponent,
        UploadImageDirective
    ]
})
export class ComponentsModule {
}
